<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/U58goQ/tc-custom/9781466853904.jpg?1720011206150" alt="This image is the cover for the book Red Nile"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Red Nile
      </h1>
      <p class="bookDescription body article font2">
        <p>From religion, to language, to the stories rooted in our faith and history books, the Nile River has proven to be a constant fixture in mankind's tales. In this dazzling, idiosyncratic journey from ancient times to the Arab Spring, <i>Red Nile</i> navigates a meandering course through the history of the world's greatest river, exploring this unique breeding ground for creativity, power clashes, and constant change.<br/><br/>Seasoned historical writer Robert Twigger connects the comprehensive history of the Nile with his personal experience of living in Egypt while researching the Nile's historical origins. Twigger covers the entirety of the river, charting the length of the Nile from its disputed origins through Africa on a whirlwind tour of the rulers, explorers, conquerors, generals, and novelists who painted the Nile "red." Both comprehensive and intimate, this narrative guides readers through history by way of the mighty river known across the world.<br/><br/>The result of this meticulously researched book is an all-inclusive history of this epic river and the incredible connections throughout history. The stories of excess, love, passion, splendor, and violence are what make the Nile so engaging, even after centuries of change.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Twigger
      </h2>
      
      <p class="authorDescription body article"><P>Robert Twigger attended Oxford University and later spent a year training at Martial Arts with the Tokyo Riot Police. He has won the Newdigate prize for poetry, the Somerset Maugham award for literature and the William Hill Sports Book of the Year award. In addition to writing books, he has written for <I>Esquire, Maxim,</I> the <I>Daily Telegraph,</I> and the <I>Financial Times.</I> He divides his time between Cairo and the United Kingdom.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Dunne Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?89cfcba0